import React, { useEffect } from "react";
import { useState } from "react";
import { Grow, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { QRCodeSVG } from "qrcode.react";

const QRCodeDialog = ({ open = false, qrString = "", infoString = "", onClose }) => {
  return (
    open && (
      <Grow in={open} style={{ transformOrigin: "50% 100% 0" }} timeout={500}>
        <Box
          border={3}
          borderRadius={3}
          borderColor={"gray"}
          paddingBottom={5}
          height={200} // Fixed height
          width={300} // Fixed width
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          position="fixed" // Changed to 'fixed'
          top="50%"
          left="50%"
          style={{
            transform: "translate(-50%, -50%)", // Centering the box
          }}
          bgcolor="white"
          zIndex={1500}
        >
          <IconButton
            onClick={onClose}
            style={{
              color:"white",
              background:"gray",
              position: "absolute",
              top: '0%',
              right: '0%',
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography mt={3} mb={1} fontSize={"18pt"} fontWeight={"bold"}>
            {infoString}
          </Typography>
          {qrString ? <QRCodeSVG value={qrString} size={128} /> : null}
        </Box>
      </Grow>
    )
  );
};

export default QRCodeDialog;
